import * as React from 'react';
import { Utils, NumberFormatter, domainVal, DateFormatter, i18n, isAuth } from 'arm-common';
import FondiAction from './fondi_action'
import ProdottoActions from './../prodotto/prodotto_actions'
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import { AppConstants } from '../../constants/AppConstants';
import { resolve } from 'path';
import { reject } from 'lodash';
import AppActions from '../../app/app_actions';
import ApplicationData from '../../app/aApplicationData';
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx';
import FondiDocumentUpload from './../prodotto/FondiDocumentUpload.jsx'

class FondoCard extends React.Component {
    constructor(props) {
        super(props);
        this.createFondi = this.createFondi.bind(this);
        this.state = {
            disabilitaSwitch: false,
            validationProdotto: new Map(),
            validationSottoStanti: new Map(),
            showConfirm: false,
            modificaFondo: false,
            showUpload: false,
            showUploadLinea: false,
            idProdottoLineaFondo: null,
            idProdotto: null,
            showDel: false,
            showConfirmDelete: false,
            showConfirmDeleteLinea: false,
            fondoDaEliminare: null,
            validation: new Map(),
            docDaEliminare: null,
            idProdottoFondo: null
        }

        this.showConfirmDelete = this.showConfirmDelete.bind(this);
        this.showConfirmDeleteLinea = this.showConfirmDeleteLinea.bind(this);
        this.eliminaProdottoFondi = this.eliminaProdottoFondi.bind(this);
        this.cancelUploadDoc = this.cancelUploadDoc.bind(this);
        this.uploadDoc = this.uploadDoc.bind(this);
        this.inzializzaEliminaDocument = this.inzializzaEliminaDocument.bind(this);
        this.deleteProdottoLineaFondoDocument = this.deleteProdottoLineaFondoDocument.bind(this); 
        this.columnDelete = this.columnDelete.bind(this); 
        this.columnDeleteDoc = this.columnDeleteDoc.bind(this); 
        this.showConfirmPanelProdotto = this.showConfirmPanelProdotto.bind(this); 
        this.inizializzaNuovoProdotto = this.inizializzaNuovoProdotto.bind(this);
        this.inputChangeHandlerProdottiFondo = this.inputChangeHandlerProdottiFondo.bind(this);
        this.validateFormProdotto = this.validateFormProdotto.bind(this);
        this.salvaProdottoLineaLibera = this.salvaProdottoLineaLibera.bind(this);
        this.componentName = '[FondoCard.jsx] ';
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');
        let idFondo = this.props.id;
        this.props.getListProdottoFondi(idFondo);
        this.props.getListProdottoLineaLibera();
        let columns = [
            { field: 'idProdottoLineaFondo', title: 'Id', sortable: 'true' },
            { field: 'nomeProdotto', title: i18n('ARM_CORE_PRODUCT.MANAGE.PRODOTTO', 'Prodotto') },
            { field: 'percMin', title: i18n('ARM_CORE_PRODUCT.MANAGE.PERC_MIN', '% Min') },
            { field: 'percMax', title: i18n('ARM_CORE_PRODUCT.MANAGE.PERC_MAX', '% Max') },
            { field: 'elimina', title: 'Elimina', formatter: this.columnDelete, },
            { field: 'docId', title: 'KID', formatter: this.uploadDoc, },
            { field: 'docIdDel', title: 'Elimina KID', formatter: this.columnDeleteDoc, }

        ];


        $(this.refs.prodottoTable).bootstrapTable({
            columns: columns,
            idField: "idProdotto",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            clickToSelect: true,
            maintainMetaData: true,
            maintainSelected: true,
            onClickRow: (row, $element, field) => this.detailsOnClick(row, $element, field),
            sortOrder: "desc",
            pagination: true,


        });

        if (this.props.listaProdottiPerFondo) {
            $(this.refs.prodottoTable).bootstrapTable('load', this.props.listaProdottiPerFondo);
        }

    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');
        if (nextProps.listaProdottiPerFondo && nextProps.listaProdottiPerFondo && nextProps.listaProdottiPerFondo) {
            if (nextProps.listaProdottiPerFondo !== this.props.listaProdottiPerFondo) {
                $(this.refs.prodottoTable).bootstrapTable('load', nextProps.listaProdottiPerFondo);
            }
        }
    }

    dataFormat(value, row, index) {
        if (value === "0") {
            return "-";
        }
        return DateFormatter.dataFormatter(value);
    }

    inzializzaEliminaStrumCmp(idProdottoLineaFondo) {
    this.setState({fondoDaEliminare: idProdottoLineaFondo, showConfirmDelete: true });
     }


     inputChangeHandlerProdottiFondo(e) {
        let id = e.target.id;
        let value = e.target.value;
        let idFondo = this.props.id;
        if (this.state.validation.has(id)) {
            this.state.validation.delete(id);
        }
        
       
        if(id === "idProdotto"){
           this.props.getLinea(value).then(
             resolve =>{ 
                 this.props.inputChangeHandlerProdotti("idLinea", resolve.idProdottoLinea); 
                 return resolve;
                
             }
           );
       
        }

        this.props.inputChangeHandlerProdotti(id, value).then(
            resolve =>{
                if (id === "idProdotto") {
                    if (this.props.listaProdottiPerFondo) {
                        let fondoTrovato = this.props.listaProdottiPerFondo.find(fon => fon.idFondo === this.props.id);
                        if (fondoTrovato) {
                            this.props.inputChangeHandlerProdotti("idFondo", fondoTrovato.idFondo);
                            this.props.inputChangeHandlerProdotti("codIsin", fondoTrovato.codIsin);
                            this.props.inputChangeHandlerProdotti("fonDescrizione", fondoTrovato.fonDescrizione);

                        }else{
                            if(this.props.id !== null && this.props.id !== undefined){
                                this.props.inputChangeHandlerProdotti("idFondo",this.props.id);  
                           }
                        }
                    }
                }
                this.validateFormProdotto(); 
            }
        );

    }


     validateFormProdotto() {

        let required = ['percMin', 'percMax', 'idProdotto'];
        let validation = new Map();
        for (let i = 0; i < required.length; i++) {

            if (this.props.fondo[required[i]] === null || this.props.fondo[required[i]] === undefined || this.props.fondo[required[i]] === "") {
                validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }

            if (required[i] === "idProdotto") {
                let indexTrovato = this.props.listaProdottiPerFondo.findIndex(fon => fon.idProdotto === this.props.fondo.idProdotto);

                if (indexTrovato !== -1) {
                    validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_ESISTENTE_LISTA', 'Prodotto gia aggiunto sulla lista'));
                }
            }
        }

        let fondo = this.props.fondo;

        if (fondo.percMin && fondo.percMin !== "") {
            if (fondo.percMin > 100) {
                validation.set("percMin", i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MAX_ALLOWED', 'valore massima permessa:') + "100");
            }
        }

        if (fondo.percMin && fondo.percMax &&
            Number(fondo.percMax) < Number(fondo.percMin)) {
            validation.set("percMax", i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MINORE_DA_MINIMA', '% massima minore della % mininima'));
        }

        if (fondo.percMax && fondo.percMax !== "") {
            if (fondo.percMax > 100) {
                validation.set("percMax", i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MAX_ALLOWED', 'valore massima permessa:') + "100");
            }
        }

        this.setState({validationProdotto: validation })
        if (validation.size === 0) {
            return true;
        }
        return false;
     }


     detailsOnClick(row, $element, field) {
        console.log(this.componentName + " deatilsOnClick: " + row.idFondo);
        let fonId = row.idFondo;
        let idProdottoLineaFondo = row.idProdottoLineaFondo;
        this.props.getListProdottoFondi(fonId).then(
            resolve => {
                return resolve
            },
            reject => {
                console.log(this.componentName + ' KO');
            }
        )
        if (field === "elimina") {
            this.inzializzaEliminaStrumCmp(idProdottoLineaFondo); 
        }else if (field === "docId") {
            if (row.docId) {
                this.downloadOnClick(row.docId)
            } else if (row.idProdottoLineaFondo) {
                this.setState({ idProdottoLineaFondo: row.idProdottoLineaFondo })
                this.setState({ idProdotto: row.idProdotto})
                this.setState({idProdottoFondo: row.idFondo})
                this.setState({ showUpload: !this.state.showUpload })
            }
        }else if (field === "docIdDel" ) {
            if (row.idProdottoLineaFondo && row.docId)
            this.inzializzaEliminaDocument(row.idProdottoLineaFondo);

        }
    }

    inzializzaEliminaDocument(idDoc) {

        this.setState({ docDaEliminare: idDoc, showConfirmDeleteLinea: true });

    }

    deleteProdottoLineaFondoDocument(){
        let idFon = this.props.id;
        this.showConfirmDeleteLinea();
        this.props.deleteProdottoLineaFondoDocument(this.state.docDaEliminare).then(
            resolve => {
                $('html, body').animate({ scrollTop: 0 }, 1000);
                this.props.getListProdottoFondi(idFon);
            }
        )
    }
    showConfirmDelete() {
        this.setState({ showConfirmDelete: !this.state.showConfirmDelete });
    }

    showConfirmDeleteLinea() {
        this.setState({ showConfirmDeleteLinea: !this.state.showConfirmDeleteLinea });
    }

    eliminaProdottoFondi() {
        let idFon = this.props.id;
        this.showConfirmDelete();
        this.props.eliminaProdottoFondi(this.state.fondoDaEliminare).then(
            resolve => {
                this.props.getListProdottoFondi(idFon).then(
                    resolve => {
                        // $(this.refs.compagniaTable).bootstrapTable('load', resolve);
                    }
                )
            }
        );
    }


    salvaProdottoLineaLibera() {
        if (this.validateFormProdotto()) {
            this.showConfirmPanelProdotto();
            this.props.salvaProdottoLineaLibera().then(
                resolve => {
                    this.props.getListProdottoFondi(this.props.id).then(
                        resolve => {
                    // $(this.refs.compagniaTable).bootstrapTable('load', resolve);
                        }
                    )
                }
            )
        }
    }


    columnDelete(index) {
        console.log(this.componentName + " columnDelete: " + index);
        let temp;
        temp = "<button class='btn btn-danger btn-sm'><i class='fas fa-trash-alt' data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
        return temp;
    }

 
    uploadDoc(value, row, index) {
        let temp;
        if (row.idProdottoLineaFondo && !row.docId) {
                temp = "<button class='btn btn-primary btn-sm'><i class='fas fa-upload'></i></button>";
        } else if(row.docId) {
            temp = "<button class='btn btn-primary btn-sm'><i class='fas fa-download' data-toggle='tooltip' data-placement='top' title='Download'/></button>";
        }
        return temp;
    }

    columnDeleteDoc(value, row, index) {
        console.log(this.componentName + " columnDelete: " + index);
        let temp;
        if (row.docId) {
            temp = "<button class='btn btn-danger btn-sm'><i class='fas fa-trash-alt' disabled data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
            return temp;
        }
        //temp = "<button class='btn btn-danger btn-sm'><i class='fas fa-trash-alt' data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
        return temp;
    }

    columnDetail(value, row, index) {
        console.log(this.componentName + " columnDetail: " + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm' href='#/fondi/details'><i class='fas fa-info fa-fw' data-toggle='tooltip' data-placement='top' title='Visualizza'/></button>";
        return temp;
    }

    createFondi() {
        this.props.history.push('/fondi/create');
        this.props.clearAll();
    }

    downloadOnClick(id) {
        console.log(this.componentName + " showConfirmPanel()");
        let path = "document/download/" + id;
        this.props.downloadDocument(path);
    }

    cancelUploadDoc() {
        this.setState({ showUpload: !this.state.showUpload })
    }
    showConfirmPanelProdotto() {
        console.log(this.componentName + 'showConfirmPanel [showConfirm] ' + this.state.showConfirm);
        // this.props.showPopUP(!this.props.showConfirm);
        this.setState({ showConfirm: !this.state.showConfirm })
    }


    inizializzaNuovoProdotto() {
        this.setState({
            validationProdotto: new Map(),
            modificaFondo: false
        })
        this.props.inizializzaNuovoProdotto().then(
            resolve => {
                this.showConfirmPanelProdotto();
            }
        )

    }
    render() {
        console.log(this.componentName + ' render');
        let prodottiLineaLibera = this.props.listaProdottiLineaLibera;

        let prodottiLineaLiberaCombo = [];
        if (prodottiLineaLibera && Array.isArray(prodottiLineaLibera)) {
            prodottiLineaLibera.forEach(
                    element => {
                            let desc = element.nome;
                            if (desc) {
                                desc = element.id + "-" + element.nome;
                                // element.fonDescrizione = desc
                            } else {
                                // element.fonDescrizione = element.fonId
                                desc = element.id
                            }
                            prodottiLineaLiberaCombo.push({ idProdotto: element.id, nome: desc });
                        
                    }
                )
        }

        return (
            <div className="card">
                <div className="card-header">
                    <h3>{i18n('ARM_CORE_PRODUCT.MENUTOP.FONDI', 'Prodotti')}</h3>
                </div>
                <div className="card-body">
                <agui.aButton className="float-left mt-2" bs='primary' onClick={() => this.inizializzaNuovoProdotto()} icon="fa fa-plus" inline={true}>{i18n('ARM_CORE_PRODUCT.FONDI.AGGIUNGI_PRDOTTO', 'Aggiungi Prodotto')}</agui.aButton>

                    <table ref="prodottoTable" className={AppConstants.CLASS_TABLE} />
                    <FondiDocumentUpload show={this.state.showUpload} idProdottoLineaFondo={this.state.idProdottoLineaFondo} idProdotto={this.state.idProdotto} idProdottoFondo={this.state.idProdottoFondo} close={this.cancelUploadDoc} />
                    
                    <ConfirmModalDeleteV4
                    show={this.state.showConfirmDeleteLinea}
                    testoBody={i18n('ARM_CORE_PRODUCT.FONDI_CONFERMA', 'Confermi l\'eliminazione dell documento del fondo con id: ' + this.state.docDaEliminare)}
                    deleteOnClick={this.deleteProdottoLineaFondoDocument}
                    onClose={this.showConfirmDeleteLinea} />

                    <ConfirmModalDeleteV4
                        show={this.state.showConfirmDelete}
                        testoBody={i18n('ARM_CORE_PRODUCT.COMPAGNIA.CONFERMI_ELIMINA_StrumCmp', 'Confermi l\'eliminazione del prodotto con fondo con id: ' + this.state.fondoDaEliminare)}
                        deleteOnClick={this.eliminaProdottoFondi}
                        onClose={this.showConfirmDelete} />





          <agui.ConfirmModalOkCancelV4 show={this.state.showConfirm} >
                    <agui.ConfirmModalOkCancelV4.Header testoTitle="Associazione Prodotto" onClose={this.showConfirmPanelProdotto} />
                    <agui.ConfirmModalOkCancelV4.Body testoBody="">

                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ASelectV4
                                    id="idProdotto"
                                    disabled={false}
                                    onChange={this.inputChangeHandlerProdottiFondo}
                                    value={this.props.fondo ? this.props.fondo.idFondo : null}
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO_ID', 'Prodotto con linea libera')}
                                    items={prodottiLineaLiberaCombo}
                                    validation={this.state.validationProdotto}
                                    valueKey="idProdotto"
                                    labelKey="nome"
                                />
                            </div>
                        </div>

                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4 id="percMin" type="number"
                                    value={this.props.fondo ? this.props.fondo.percMin : null}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.PERC_MIN', '% min')}
                                    required={true}
                                    minValueAllowed={0}
                                    validation={this.state.validationProdotto}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.PERC_MIN', '% min')}
                                    onChange={this.inputChangeHandlerProdottiFondo} 
                                    />
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4 id="percMax" type="number"
                                    value={this.props.fondo ? this.props.fondo.percMax : null}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.PERC_MAX', '% max')}
                                    required={true}
                                    minValueAllowed={0}
                                    validation={this.state.validationProdotto}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.PERC_MAX', '% max')}
                                    onChange={this.inputChangeHandlerProdottiFondo}
                                    />
                            </div>
                        </div>

                    </agui.ConfirmModalOkCancelV4.Body >
                    <agui.ConfirmModalOkCancelV4.Footer testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                        confirmOnClick={this.salvaProdottoLineaLibera} onClose={this.showConfirmPanelProdotto}>
                    </agui.ConfirmModalOkCancelV4.Footer>
                </agui.ConfirmModalOkCancelV4>
                </div>
            </div>
        );
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getListaFondi() {
            return dispatch(FondiAction.getListaFondi());
        },
        clearAll() {
            return dispatch(FondiAction.clearAll());
        },
        getFondoDetails(fonId) {
            return dispatch(FondiAction.getFondoDetails(fonId));
        },
        removeOptionFromList(indexLinea, indexFondo) {
            return dispatch(ProdottoActions.removeOptionFromList(indexLinea, indexFondo))
        },

        addOptionButton(indexLinea) {
            return dispatch(ProdottoActions.addOptionButton(indexLinea))
        },
        inizializzaModificaFondo(row) {
            return dispatch(ProdottoActions.inizializzaModificaFondo(row))
        },
        getListProdottoFondi(idFondo) {
            return dispatch(FondiAction.getListProdottoFondi(idFondo));
        },
        eliminaProdottoFondi(idProdottoLineaFondo) {
            return dispatch(ProdottoActions.eliminaProdottoFondi(idProdottoLineaFondo))
        },
        deleteProdottoLineaFondoDocument(id) {
            return dispatch(ProdottoActions.deleteProdottoLineaFondoDocument(id))
        },
        inizializzaNuovoProdotto() {
            return dispatch(ProdottoActions.inizializzaNuovoProdotto())
        },
        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },
        getListProdottoLineaLibera() {
            return dispatch(ProdottoActions.getListProdottoLineaLibera());
        },
        inputChangeHandlerProdotti(name, value) {
            return dispatch(ProdottoActions.inputChangeHandlerProdotti(name, value))
        },
        salvaProdottoLineaLibera() {
            return dispatch(FondiAction.salvaProdottoLineaLiberaFondi())
        },
        listaProdottiFondi(idFondo) {
            return dispatch(FondiAction.listaProdottiFondi(idFondo))
        },
        getLinea(value) {
            return dispatch(FondiAction.getLinea(value))
        },
    }
}


function mapStateToProps(state) {
    return {
        fondiList: state.fondi.listFondi,
        pathToReturn: state.app.pathNameToReturn,
        showConfirm: state.app.showPopUp,
        fondo: state.prodotto.fondo,
        prodotto: state.prodotto.detailsProdotto,
        fondiList: state.prodotto.listFondiProdotto,
        listaProdottiPerFondo: state.fondi.listaProdottiPerFondi,
        listProdotto: state.prodotto.listProdotto,
        listaProdottiLineaLibera: state.prodotto.listaProdottiLineaLibera,
        detailsLinea: state.fondi.detailsLinea,
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(FondoCard);